import { GroupingSchema } from './grouping-schema.model';
import { SalesDocumentPosition } from './sales-document-position.model';
import { SalesDocument } from './sales-document.model';
import { core, _ } from '@icc/shared/helpers/b2b';

export const groupingNone: GroupingSchema = {
    name: _('SALES_DOCUMENT|Wyłączone'),
    id: 0,
    match(position: SalesDocumentPosition, document: SalesDocument): string {
        return 'none';
    },
    getName() {
        return '';
    }
};

export const groupingByType: GroupingSchema = {
    name: _('SALES_DOCUMENT|Typów produktów'),
    id: 1,
    match(position: SalesDocumentPosition, document: SalesDocument): string {
        return position.type;
    },
    getName(position: SalesDocumentPosition) {
        switch (position.type) {
            case 'complex': {
                return _('COMPLEX|Konfigurator uniwersalny');
            }
            case 'external_venetian': {
                return _('EXTERNAL_VENETIAN|Żaluzja zewnętrzna');
            }
            case 'static': {
                return _('PRODUCT|Produkt');
            }
            case 'additional': {
                return _('PRODUCT|Produkt własny');
            }
        }
        return '';
    }
};

export const groupingByDepartments: GroupingSchema = {
    name: _('SALES_DOCUMENT|Działów'),
    id: 2,
    match(position: SalesDocumentPosition, document: SalesDocument): string {
        const positionDepartment = position?.department ? position.department :null;
        return positionDepartment?.id ? positionDepartment.id.toString() : null;
    },
    getName(position: SalesDocumentPosition) {
        const positionDepartment = position?.department ? position.department :null;
        return positionDepartment?.name ? positionDepartment.name : '';
    }
};

export const groupingSchemas: Record<number, GroupingSchema> = {
    0: groupingNone,
    1: groupingByType,
    2: groupingByDepartments
};